import { Component, OnInit } from '@angular/core';
import {RSDialogComponentModel} from "../../../libs/rsnotify/rsdialog.component.model";
import { Hort360PropertySummary, Meeting} from "../../../../functions/src/types";
import {DataService} from "../../services/data.service";
import invert from "invert-color";
import {Router} from "@angular/router";

@Component({
  selector: 'app-view-meeting',
  templateUrl: './view-meeting.component.html',
  styleUrls: ['./view-meeting.component.scss']
})
export class ViewMeetingComponent extends RSDialogComponentModel implements OnInit {

  get meeting(): Meeting {
    return (this.dialogValues && this.dialogValues.meeting) || {} as Meeting;
  }
  get properties(): Hort360PropertySummary[] {
    return (this.dialogValues && this.dialogValues.properties) || [] as Hort360PropertySummary[];
  }
  get propertyAttendees(): {[key: number]: number } {
    return (this.dialogValues && this.dialogValues.propertyAttendees) || {};
  }

  constructor(private dataService: DataService, private router: Router) {
    super();
  }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

  ngOnInit(): void { }

  selectAttendee(property: Hort360PropertySummary) {
    this.dialogHandles.close();
    this.router.navigate(['growers', property.id]);
  }

}
